{
  "authority": "https://midland-lead-auth.osmm.devtank.co.uk",
  "client_id": "osm-portal",
  "client_secret": "nYl7nQnsT5lHHBYcGP2WCVRKSwPOKFPt",
  "apiUrl": "https://midland-lead-portal.osmm.devtank.co.uk/internal",
  "dbApi": "https://midland-lead-portal.osmm.devtank.co.uk/api",
  "dbToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiY3VzdG9tZXIifQ.yG81zJ_L5RrHj6vKcJRyo6SOS-jMuOIQ53Tez-MMvEg"
}
